export default __webpack_public_path__ + "static/media/EmptyDark.43cb8010.svg";